import styled from 'styled-components';
import {
  Paper,
  ToggleGroup as SharedToggleGroup,
  theme,
  minBp
} from '@triumph/shared';

export const Wrap = styled(Paper)`
  padding: 30px 20px;
  margin-bottom: 24px;
  position: relative;

  @media ${minBp('desktop')} {
    padding: 43px 62px;
  }
`;

export const Title = styled.h3`
  margin: 0 0 11px;
  font-size: 20px;
  line-height: 24px;
  font-family: ${theme.fonts.dinDemi};
  text-transform: uppercase;

  @media ${minBp('desktop')} {
    font-size: 22px;
    line-height: 30px;
    margin: 0 0 8px;
  }
`;

export const Description = styled.div`
  font-size: 14px;
  padding-bottom: 18px;
  border-bottom: 1px solid ${theme.colors.hairline};
  margin-bottom: 27px;

  @media ${minBp('desktop')} {
    font-size: 16px;
    padding-bottom: 30px;
    margin-bottom: 40px;
  }
`;

export const Breakdown = styled.div`
  padding: 0 0 27px;
  margin: 0 0 20px;
  border-bottom: 1px solid ${theme.colors.hairline};

  @media ${minBp('desktop')} {
    display: flex;
    align-items: center;
    margin-bottom: 30px;
    padding: 0 0 50px;
  }
`;

export const BreakdownDetails = styled.div`
  @media ${minBp('desktop')} {
    flex: 1;
    margin-right: 120px;
  }
`;

export const BreakdownTitle = styled.h4`
  margin: 0 0 8px;
  font-size: 14px;
  line-height: 20px;
  font-family: ${theme.fonts.dinDemi};
  text-transform: uppercase;

  @media ${minBp('desktop')} {
    margin: 0 0 16px;
    font-size: 16px;
  }
`;

export const BreakdownDescription = styled.div`
  font-size: 14px;
  line-height: 22px;
  margin: 0 0 17px;

  & > p:last-child {
    margin: 0;
  }

  p {
    line-height: 22px;
  }

  @media ${minBp('desktop')} {
    margin: 0;
  }
`;

export const BreakdownImageWrap = styled.div`
  width: 100%;
  max-width: 450px;
  margin: 0 auto;

  @media ${minBp('desktop')} {
    max-width: 320px;
    padding-right: 60px;
  }
`;

export const BreakdownImage = styled.img`
  width: 100%;
  height: auto;
  margin: 0 auto;
  vertical-align: middle;
  object-fit: contain;
`;

export const BreakdownImageLabels = styled.div`
  margin-top: 33px;
  display: flex;
  align-items: center;
  justify-content: ${({ count }) => (count === 1 ? 'center' : 'space-between')};
`;

export const BreakdownImageLabel = styled.div`
  max-width: 25%;
  text-align: center;
  font-size: 10px;

  @media ${minBp('tablet')} {
    font-size: 12px;
  }
`;

export const Summary = styled.div`
  font-size: 13px;
  line-height: 22px;

  @media ${minBp('desktop')} {
    font-size: 14px;
  }
`;

export const QuoteWrapper = styled.div`
  border-top: 1px solid ${theme.colors.hairline};
  margin-top: 27px;

  ${({ $bordered }) =>
    $bordered &&
    `
      padding-top: 18px;
      border-top: 1px solid ${theme.colors.hairline};
    `}

  ${({ $highlight }) =>
    $highlight &&
    `
      font-size: 20px;
      text-align: left;
      font-weight: bold;
      color: ${theme.colors.heading};
      border-top: 0;
    `}

  @media ${minBp('desktop')} {
    margin-top: 30px;

    ${({ $bordered }) => $bordered && `padding-top: 30px;`}
  }
`;

export const ChoiceOuter = styled.div`
  @media ${minBp('desktop')} {
    display: flex;
    margin: 0 0 30px;
  }
`;

export const ToggleGroup = styled(SharedToggleGroup)`
  @media ${minBp('desktop')} {
    flex: 1;
  }
`;

export const EditButton = styled.button`
  appearance: none;
  background: transparent;
  padding: 0;
  margin: 0;
  border: 0;
  color: ${theme.colors.primary};
  font-size: 16px;
  font-family: inherit;
  text-transform: uppercase;
  position: absolute;
  top: 30px;
  right: 20px;

  @media ${minBp('desktop')} {
    top: 43px;
    right: 62px;
  }
`;

export const YourFinanceQuote = styled.button`
  background-color: ${theme.colors.primary};
`;
